import Vue from 'vue';
import 'babel-polyfill';
import ElementUI from 'element-ui';

import axios from 'axios';
import qs from 'qs';

import '../../assets/styles/default.css';
import 'element-ui/lib/theme-default/index.css';
import '../../assets/styles/theme.less';
import '../../assets/styles/iconfont.css';
import AccountSystem from './AccountSystem.vue';
import router from './router';

Vue.use(ElementUI);

//在应用启动时，可以通过设置 Vue.config.productionTip = false 来关闭生产模式下给出的提示
Vue.config.productionTip = false;

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.filter('encrypt', (value, type) => {
  if (/^\d{11}$/.test(value) && type === 'phone') {
    return value.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
  } else if (type === 'name') {
    return value.slice(0, 1) + '**';
  }
  return value;
});

global.vm = new Vue({
  el: '#app',
  router,
  template: '<AccountSystem />',
  components: {AccountSystem}
});



// WEBPACK FOOTER //
// ./src/router/AccountSystem/account.js